module.exports = __webpack_public_path__ + "static/media/boy-24.5e9e0ad0.svg";